//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { QueryRenderer, ReadyState } from "react-relay";
// chrome-feed imports
import * as styles from "./ChromeFeed.styles";
import { IRendererProps, IRendererContainer } from "./ChromeFeed.d";
import { ChromeFeed } from "./ChromeFeed";
// other internals
import { queries } from "./ChromeFeedRenderer.gql";
import { IReduxState } from "@state/reducers/root.reducer";
import { handleReadyStateError } from "@util/relay.util";
import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";
import { CalloutError } from "@components/callout-error";

//////////////////
// COMPONENT
//////////////////
class ChromeFeedRendererWrapper extends React.PureComponent<IRendererProps, {}> {
  private staleViewer: ISchema.IViewer | undefined;

  public render() {
    return (
      <QueryRenderer
        environment={this.props.environment}
        query={queries}
        variables={{ refetch: this.props.refetch }}
        cacheConfig={{}}
        render={(readyState: ReadyState) => {
          // check for error or show a loader for first load
          if (readyState.error) {
            handleReadyStateError(readyState.error, "ChromeFeedRenderer");

            return <CalloutError style={{ marginTop: 8 }} readyState={readyState} />;
          } else if (readyState.props) {
            // fetch complete
            this.staleViewer = readyState.props.viewer;
            return (
              <ChromeFeed
                viewer={readyState.props.viewer}
                fastCrawlFinished={this.props.fastCrawlFinished}
              />
            );
          } else if (!!this.staleViewer) {
            // fetch incomplete
            return (
              <ChromeFeed
                viewer={this.staleViewer}
                fastCrawlFinished={this.props.fastCrawlFinished}
              />
            );
          } else {
            return (
              <div style={styles.background}>
                <CircularProgress />
              </div>
            );
          }
        }}
      />
    );
  }
}

//////////////////
// REDUX
//////////////////

function mapStateToProps(state: IReduxState, _ownProps: IRendererContainer) {
  return {
    refetch: state.chromeFeed.refetchFeed,
    fastCrawlFinished: state.onboarding.fastCrawlFinished,
  };
}

export const ChromeFeedRenderer = connect(mapStateToProps)(ChromeFeedRendererWrapper);
